import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { TrimmedRequiredValidator } from '../../../core/validators/trimmed-required.validator';
import { ErrorMessagesComponent } from '../error-messages/error-messages.component';

@Component({
  imports: [
    ErrorMessagesComponent,
    MatButton,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatError,
    MatFormField,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    TranslatePipe,
  ],
  selector: 'app-duplicate-dialog',
  styleUrl: './duplicate-dialog.component.scss',
  templateUrl: './duplicate-dialog.component.html',
})
export class DuplicateDialogComponent {
  public readonly addEditForm: FormGroup<{ name: FormControl<string | null> }> = new FormGroup({
    name: new FormControl('', [Validators.required, TrimmedRequiredValidator(), Validators.maxLength(255)]),
  });
  public readonly title = '';

  constructor(
    private readonly dialogRef: MatDialogRef<DuplicateDialogComponent>,
    private readonly translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: { context: string },
  ) {
    this.title = this.translate.instant('sharedComponent.duplicateDialog.title', {
      context: this.translate.instant(this.data.context),
    });
  }

  public onFormDialogSubmit(): void {
    if (!this.addEditForm.valid) {
      return;
    }

    this.dialogRef.close(this.addEditForm.value.name);
  }
}
